<template>
  <h2 class="content-block">Operators</h2>
  <div v-if="loading" class="loading-overlay">
    LOADING...
    <span class="loader"></span>
  </div>
  <div v-else>

  <DxDataGrid class="dx-card wide-card" :data-source="operators" :selection="{ mode: 'single' }" :show-borders="true"
    :columns-auto-width="true" :column-min-width="50" :hover-state-enabled="true" :key-expr="operatorId"
    @selection-changed="onSelectionChanged" :filter-builder="filterBuilder" :filter-value="filterValue"
    :column-resizing-mode="nextColumn" :allow-column-resizing="true" style="max-height: 80vh"
    @initialized="saveGridInstance" @exporting="onExporting">

    <!-- <DxExport :enabled="true" :formats="['xlsx', 'pdf', 'csv']" /> -->
    <DxExport :enabled="true" />

    <DxToolbar>
      <DxItem location="before" template="addRecordTemplate" />
      <DxItem location="after" template="refreshRecordTemplate" />
      <DxItem location="after" template="removeFilterRecordTemplate" />
      <DxItem location="after" name="exportButton" />
      <DxItem location="after" name="columnChooserButton" />

    </DxToolbar>

    <template #addRecordTemplate>
      <DxButton icon="add" @click="newRec" />
    </template>
    <template #refreshRecordTemplate>
      <DxButton icon="refresh" @click="refreshData" />
    </template>
    <template #removeFilterRecordTemplate>
      <DxButton icon="filter" @click="removeFilter" />
    </template>

    <DxLoadPanel :enabled="true" />
    <DxColumnChooser :enabled="true" mode="select" />
    <DxFilterRow :visible="true" />
    <DxHeaderFilter :visible="true" />
    <DxScrolling mode="virtual" />

    <DxColumn data-field="operatorName" caption="Name" />

  </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxFilterRow,
  DxScrolling,
  DxColumnChooser,
  DxLoadPanel,
  DxToolbar,
  DxItem,
  DxExport
} from "devextreme-vue/data-grid";

import { DxButton } from 'devextreme-vue/button';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxFilterRow,
    DxScrolling,
    DxColumnChooser,
    DxLoadPanel,
    DxButton,
    DxToolbar,
    DxItem,
    DxExport
  },
  created() {
    this.loadPageData();
  },
  data() {
    return {
      loading: true,
      dataGridInstance: null,
      currentOperator: null,
    };
  },
  computed: {
    operators() {
      return this.$store.getters["operators/getOperators"];
    },
  },
  methods: {
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },
    newRec() {
      this.$router.push({ name: 'operator-details', params: { id: 0 } });
    },
    removeFilter() {
      this.dataGridInstance.clearFilter("row");
    },
    refreshData() {
      this.loadPageData();
    },
    onSelectionChanged({ selectedRowsData }) {
      this.$router.push({ name: 'operator-details', params: { id: selectedRowsData[0].operatorId } });
    },
    async loadPageData(refresh = false) {
      this.loading = true;
      try {
        await this.$store.dispatch("operators/loadOperators", {
          forceRefresh: refresh,
        });
      } catch (error) {
        this.error = error.message || "Unexpected Error.";
      } finally {
        this.loading = false;
      }
    },
    onExporting(e) {
      e.fileName = `OperatorsDataExport_${new Date().toISOString().slice(0, 10)}`;
    }
  },
};
</script>

